import { signal } from '@preact/signals-react'

export const installationListSignal = signal([])
export const installationListLoadingSignal = signal(false)
export const installationListErrorSignal = signal(null)